module.exports = __webpack_public_path__ + "img/BreakfastTreats.061c85cf.png";